import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardHeader from 'common/components/card-header';
import CardContent from 'common/components/card-content';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import './index.scss';

const identity = (x) => x;

export default class NoDataCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    priorityWarnings: PropTypes.array,
    reportId: PropTypes.number.isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    warnings: PropTypes.array,
  };

  static defaultProps = {
    connectDragSource: identity,
    disableConfig: false,
    priorityWarnings: [],
    subtitle: '',
    title: '',
    warnings: [],
  };

  render() {
    return this.props.connectDragSource(
      <div>
        <Card className={'NoDataCard'}>
          {this.props.title || this.props.subtitle ? (
            <CardHeader
              disableConfig={this.props.disableConfig}
              disableDownload={true}
              disableDownloadCsv={true}
              disableDownloadPointsCsv={true}
              priorityWarnings={this.props.priorityWarnings}
              reportId={this.props.reportId}
              subtitle={this.props.subtitle}
              title={this.props.title}
              warnings={this.props.warnings}
            />
          ) : null}
          <CardContent>
            <SvgSymbol className={'drag-drop'} name={'drag-drop'} />
            <span className={'NoDataCard-caption'}>
              {t('No data to display')}
            </span>
          </CardContent>
        </Card>
      </div>,
    );
  }
}
